import { useStore as getStore } from "../../utils/useStore.js";
import popupContextMenuFactory from "./popupContextMenuFactory.js";

const initialState = () => ({
  position: { left: 0, top: 0 },
  isOpen: false,
  content: null,
  delay: false,
  fileId: null,
});

const [PopupContextMenuProvider, usePopupContextMenu, withPopupContextMenu] =
  getStore(popupContextMenuFactory, initialState, "Popup");

export const popupContextMenuInitState = initialState();

export { usePopupContextMenu, PopupContextMenuProvider, withPopupContextMenu };

export default PopupContextMenuProvider;
